import { Component, OnInit } from '@angular/core';
import { LoginInfoComponent } from "../../user/login-info/login-info.component";
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';


@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  tokenContent: any;
  hasMembership: string;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.tokenContent = this.authService.getCurrentUserRoles();
    this.hasMembership = this.authService.getCurrentHasMembership();
    if (this.hasMembership === "False") {
      this.router.navigateByUrl("/firmmembership/mymembership/null");
    }

  }



}
